/*Recurso: Proposals - Variables y rutinas store que almacenan la respuesta del API y su manipulación en el front
  Tareas:
    GetSummarybyUser   
    GetDetailbyUser   
    InsertbyUser 
    UpdatebyUser
    DeletebyUser
    SendbyUser   
*/
//elementos stores: elementos que llenamos con inf. del api y otros elementos captados del front o para manejo del front
//funciones stores: rutinas que captan o modifican los elementos store
//response: { config: {}, hearders:{}, request:{}, data: { informacion: {}, resultado: {}, contenido: [{ }] } } //esto trae la lectura de api

import create from "zustand";

const proposalsStore = create((set:any, get:any) => ({
  
  objErrorProposalsStore: { hasError: false, url:'', body:'', recurso:'proposals', componente:'', idresul: 0, desresul:'', menu:'' },  //se llena con la información del api si éste tiene error

      //*Limpia objeto de error cuando éste ya se mostro en VentanaObjeErrorAPI
      limpiaObjErrorProposalsStore: () => { 
        let paso = { hasError: false, url:'', body:'', recurso:'proposals', componente:'', idresul:0, desresul:'', menu:''}
        set( { objErrorProposalsStore: paso } );
        //console.log('limpiaObjErrorProposalsStore (sale) - objErrorProposalsStore: ', get().objErrorProposalsStore);
      },

      //*Error en api: entra a esta función cuando el servicio cae en catch y muestra el error en VentanaObjError
      generaObjErrorProposalsStore: async (responseAPI:any, h:any, h2:any, e:any, c:any, m:any) => {  
        //alert('proposalsStore - generaObjErrorProposalsStore:');
        //console.log('****generaObjErrorProposalsStore (entra): ', responseAPI);
        //console.log('*generaObjErrorProposalsStore (entra): h: ', h , ' h2: ',  h2 , ' e: ', e , ' c: ', c );
        let paso = { hasError: h, url:'', body:e, recurso:'proposals', componente:c, idresul:0, desresul:'', menu:m }
        if (responseAPI==undefined  || responseAPI=='Error: Network Error'){
          paso.idresul=-1;
          paso.desresul= 'Error inesperado, asegure su conexión con internet y vpn';
        }
        else if (responseAPI=='Error detectado por api en ret') {
          paso.desresul= h;
          paso.idresul= h2; 
        }
        else {
          let temp = responseAPI.config;
          paso.url = temp.url;
          if (responseAPI.data!="" && responseAPI.data!=null){
            paso.idresul=responseAPI.data.ret;
            paso.desresul= responseAPI.data.msjerror;
          }    
          else {
              paso.idresul= responseAPI.status;
              switch(responseAPI.status){
                //case 404:  paso.desresul= "El usuario no existe"; break;
                case 401:  paso.desresul= "No autorizado"; break;
                case 404:  paso.desresul= "No tiene información, error al leer la tarea del API"; break;
                default: paso.desresul= responseAPI.statusText; break;
              }
          }    
        }
        set( { objErrorProposalsStore: paso } );
        console.log('***generaobjErrorProposalsStoreStore (sale) - objErrorProposalsStore: ', get().objErrorProposalsStore);
      },

  propuestasStore: [], //response de getSummarybyUserStore +  elementos de uso en el front

      limpiaPropuestasStore: async (responseAPI:any) => {
        set( { propuestasStore: [] } );
        //console.log('0. limpiaPropuestasStore - propuestasStore:', get().propuestasStore)
      },

      //*Tarea: GetSummarybyUser // se ejecuta al entrar en Propuesta dentro de useEffect: Carga las propuestas existetes dentro propuestasStore mas los elementos que se ocupan para el front
      guardaGetSummarybyUserStore: async (responseAPI:any) => {  //recibo response.data
        //console.log('guardaGetSummarybyUserStore - responseAPI:', responseAPI)
        set( { propuestasStore: [] } );
        set( { propuestasStore: responseAPI } );
        let propuestaDetalles:any =  {};

        //preparamos propuestaStore con lo necesario para visualizar en front
          get().propuestasStore.map((p:any, index:any) => {
                propuestaDetalles = { 
                  id: 0, folio:'', description:'', createdAt:'', sentAt:null, sent:false, user:{}, origin:[], processxfrequency: [],
                  abierto: false, disabled:false, fecha:'', estatusTexto: '',
                  btnGuardar:true, btnEnviar:false,  btnEliminar:false, 
                  miCatOrigenes: [],
                  miCatProcesos: []
                };
                p.abierto = false; //por omisión entra cerrado
                p.disabled = (p.sent) ? true : false;
                p.eliminado = false;
                p.estatusTexto = (p.sent) ? "Enviada" : "No enviada";
                p.fecha = p.createdAt.substring(0,10);
                p.nombreCorto= (p.description.length > 50) ? p.description.substring(0,10) + '...' : p.description; 
                
                p.propuestaDetalles = propuestaDetalles;
          });
          
          //console.log ('1.....propuestasStore: ', get().propuestasStore );
          return(get().propuestasStore);
      },

  propuestaNvaStore: {},

      //*Preparamos el objeto por si asignan una propuesta nueva //se activa en Propuesta - botón: Agregar propuesta de cambio 
      agregaPropuestaNvaStore: (catO:any, catP:any) => {  
        //console.log('catO:',catO, 'catP:',catP);
        let date = new Date();
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        let fecha = '';
        if (month < 10) { fecha= `${year}-0${month}-${day}` }
        else { fecha= `${year}-${month}-${day}` };
        get().propuestaNvaStore= { 
              id: 0,  folio:'Nuevo', description: '', createdAt: date, sentAt: null, sent: false, 
              abierto: true, disabled:false, eliminado: false,  estatusTexto: 'No enviada', fecha: fecha, nombreCorto: '', 
              propuestaDetalles:{ 
                id: 0, folio:'Nuevo', description: '', createdAt: date, sentAt: null, sent: false, user:{}, origin: [], processxfrequency: [],
                abierto: true, disabled:false, fecha:fecha, estatusTexto: 'No enviada',
                btnGuardar:true, btnEnviar:false,  btnEliminar:false,
                miCatOrigenes: catO,
                miCatProcesos: catP
            }
          };
        //console.log (':::agregaPropuestaNvaStore - propuestaNvaStore: ', get().propuestaNvaStore );
      },
  
  propuestaDetallesVacia: { 
    id: 0, folio:'', description:'', createdAt:'', sentAt:null, sent:false, user:{}, origin:[], processxfrequency: [],
    abierto: false, disabled:false, fecha:'', estatusTexto: 'No enviada',
    btnGuardar:true, btnEnviar:false, btnEliminar:false, 
    miCatOrigenes: [],
    miCatProcesos: []
  }, //formato vacio de getDetailbyUserStore +  elementos de uso en el front lo asignamos en guardaGetSummarybyUserStore
    
  propuestaDetallesStore: {}, //recibe respuesta de la tarea getDetailbyUserStore +  elementos de uso en el front
  
      //*Tarea: GetSummarybyUser, accesa a los detalles de la propuesta existente // se ejecuta al entrar en Propuesta al seleccionar el panel x propuesta // carga en propuestasStore el elemento seleccionado de detalle
      guardaGetDetailbyUserStore: async (responseAPI:any, id:any, catO:any, catP:any, dondeViene:any) => { //recibo response.data
        //console.log('.... guardagetdetailbyuser -responseAPI:', responseAPI)
        //console.log('.... guardagetdetailbyuser -catP:', catP)
        var _ = require('underscore');
        let activaBtnEnviar = true; //aquí vamos captando si esta completa la plantila para activar el botón enviar desde que abre

        if (responseAPI.ret==1) { //sin error
          set( { propuestaDetallesStore:  get().propuestaDetallesVacia } )
          set( { propuestaDetallesStore: responseAPI.item } )
          switch (dondeViene){
            case 'Propuesta': 
                  //console.log ('guardaGetDetailbyUserStore - Propuestas');

                  let propuestaDetalles = get().propuestaDetallesVacia;
                  propuestaDetalles =  responseAPI.item;
                  
                  if ( propuestaDetalles.sent ) { //solo para visualización
                      activaBtnEnviar = false;
                      //CatO
                      propuestaDetalles.miCatOrigenes = propuestaDetalles.origin;
                      propuestaDetalles.miCatOrigenes.map((o:any) => {
                          o.activo = true;
                          o.disabled = true;
                      }); 
                      //CatP 
                      propuestaDetalles.miCatProcesos = propuestaDetalles.processxfrequency;
                      propuestaDetalles.miCatProcesos.map((p:any) => {
                          p.activo = true;
                          p.disabled = true;
                      });
                      //console.log('.............propuestaDetalles', propuestaDetalles); 
                  }
                  else {  //puede modificar, tenemos que mandar catálogos completos y con la inf. que traiga del api                    
                      activaBtnEnviar = true;
                      //console.clear();
                      //Descripcion
                        if (propuestaDetalles.description == null || propuestaDetalles.description== '') { activaBtnEnviar = false}
                      //CatO
                        propuestaDetalles.miCatOrigenes = catO;
                        let pasoCatO:any = [];
                        pasoCatO = _.pluck(propuestaDetalles.origin, 'id');
                        //console.log ('pasoCatO.length:: ',pasoCatO.length);
                        //console.log ('pasoCatO:: ', pasoCatO)
                        if (pasoCatO.length > 0) {
                            propuestaDetalles.miCatOrigenes.map((o:any) => {
                                o.specification = '';
                                pasoCatO.map((po:any, indexCatO:any) => {
                                  if (o.id==po) {
                                      o.activo = true;
                                      o.disabled = false;
                                      o.specification = propuestaDetalles.origin[indexCatO].specification
                                      if (o.specification == null || o.specification== '') { activaBtnEnviar = false}
                                  }
                                });
                            });  
                        }
                        else {
                            propuestaDetalles.miCatOrigenes = catO;
                            activaBtnEnviar = false;
                        }
                        //console.log('1.............activaBtnEnviar', activaBtnEnviar);  
                        //Procesos que potencialmente serán modificados
                      //CatP
                        propuestaDetalles.miCatProcesos = catP;
                        let pasoCatP:any = [];
                        pasoCatP = _.pluck(propuestaDetalles.processxfrequency, 'id');
                        //console.log ('pasoCatP.length:: ',pasoCatP.length);
                        //console.log ('pasoCatP:: ', pasoCatP)
                        if (pasoCatP.length > 0) {
                            propuestaDetalles.miCatProcesos.map((p:any) => {
                                pasoCatP.map((pp:any, indexCatP:any) => {
                                  if (p.id==pp){ 
                                      p.activo = true;
                                      p.disabled = false;
                                  }
                                });
                            });  
                        }
                        else { activaBtnEnviar = false }
                        //console.log('2.............activaBtnEnviar', activaBtnEnviar);  
                     
                      //console.log('.............pasoCatP.length', pasoCatP.length);  
                      //console.log('.............propuestaDetalles', propuestaDetalles);  
                      //Procesos que potencialmente serán modificados
                      //console.log('.............propuestaDetalles.processxfrequency.length', propuestaDetalles.processxfrequency.length);  
                      if (propuestaDetalles.processxfrequency.length==1 && propuestaDetalles.processxfrequency[0].id==null) {  activaBtnEnviar = false }
                      //console.log('3.............activaBtnEnviar', activaBtnEnviar);  
                      ////if (pasoCatP.length==0) {  activaBtnEnviar = false }

                  }
                  propuestaDetalles.btnGuardar =  ( propuestaDetalles.sent ) ? null : false;
                  propuestaDetalles.btnEnviar = (propuestaDetalles.sent) ? null : activaBtnEnviar;
                  propuestaDetalles.btnEliminar = ( propuestaDetalles.sent ) ? null : true;


                  //console.log('propuestaDetalles.btnEnviar', propuestaDetalles.btnEnviar);
                  set( { propuestaDetallesStore: propuestaDetalles } )
                  get().cambiaPropuestasStore( id, true, get().propuestaDetallesStore, 'guardaGetDetailbyUserStore')
              break;
            case 'RPContenido': 
            case 'RDDocumentar':
                  //console.log ('guardaGetDetailbyUserStore - ResponsableDeProcesoContenido; ',  get().propuestaDetallesStore);
                  let x = get().propuestaDetallesStore.createdAt;
                  get().propuestaDetallesStore.fecha = x.substring(0,10);

                  let paso = get().propuestaDetallesStore;
                  paso.processxfrequency.map((sp:any) => {
                    switch (sp.pt_state ) {
                      case 1: sp.clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
                      case 2: sp.clasexEstatusIcono = "claseEstatus claseEstatusEdi"; break;
                      case 3: sp.clasexEstatusIcono = "claseEstatus claseEstatusIna"; break;
                      case 4: sp.clasexEstatusIcono = "claseEstatus claseEstatusHis"; break;
                      default: sp.clasexEstatusIcono= "claseEstatus claseEstatusAct"; break;
                    }
                  }); 
                  set( { propuestaDetallesStore: paso } )  
              break;   
          }
          //console.log (':::propuestaDetallesStore: ', get().propuestaDetallesStore );
          return(get().propuestaDetallesStore);
        }
        else {
          get().generaObjErrorProposalsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'proposals.store-guardaGetDetailbyUserStore')
        }
      },
      
      cambiaPropuestasStore: ( id:any, abierto:any, detalle:any, dondeViene:any) => { 
        //alert('cambiaPropuestasStore - id: ' + id + '  abierto: ' + abierto + ' detalle: '+ detalle + ' dondeViene: ' + dondeViene)
        //console.log('cambiaPropuestasStore - id: ', id ,'  abierto: ', abierto,' dondeViene: ', dondeViene, ' detalle: ', detalle)
        switch (dondeViene){
            case 'desmontoPropuesta': 
                  set( { propuestaDetallesStore: [] } )
            break;
            case 'guardaGetDetailbyUserStore': 
                    get().propuestasStore.map((p:any) => {
                      if (p.id==id) { 
                          p.propuestaDetalles = detalle;
                          p.abierto = abierto;
                          p.description= detalle.description;
                      }    
                    }); 
            break;
            case 'abreCierraPropuesta':  
                    get().propuestasStore.map((p:any) => {
                      if (p.id==id) 
                          p.abierto = abierto;
                    }); 
            break;
            case 'botonCierraPropuesta':  
                    get().propuestasStore.map((p:any) => {
                      if (p.id==id) 
                          p.abierto = abierto;
                    }); 
            break;
            case 'botonEnviar': 
                    //console.log ('4:::::::::::::::::::::::id: ', id);
                    get().propuestasStore.map((p:any) => {
                      if (p.id==id) { 
                          p.sent = true;
                          p.estatusTexto = "Enviada";
                          p.btnGuardar = null;
                          p.btnEnviar = null;
                          p.btnEliminar = null;
                          //p.abierto = true;
                          p.disabled = true;
                      }    
                    }); 
                    if (id == 0 ) {
                        get().propuestasStore[0].sent = true;
                        get().propuestasStore[0].estatusTexto = "Enviada";
                        get().propuestasStore[0].btnGuardar = null;
                        get().propuestasStore[0].btnEnviar = null;
                        get().propuestasStore[0].btnEliminar = null;
                        get().propuestasStore[0].disabled = true;

                        let paso = get().propuestaDetallesVacia;
                        paso = get().propuestasStore[0].propuestaDetalles;
                        paso.sent = true;
                        paso.btnGuardar = null;
                        paso.btnEnviar = null;
                        paso.btnEliminar = null;
                        let paso2:any = [];
                        paso.miCatOrigenes.map((co:any) => {
                          if (co.activo) { 
                              co.disable = true;
                              paso2.push(co);
                          }    
                        }); 
                        paso2 = [];
                        paso.miCatProcesos.map((cp:any) => {
                          if (cp.activo) { 
                              cp.disable = true;
                              paso2.push(cp);
                          }    
                        }); 
                        paso.miCatProcesos = paso2;
                        get().propuestasStore[0].propuestaDetalles = paso;
                    }
                  break;
            case 'recargaPropuestaNva':  
                    get().propuestaNvaStore.abierto = false;
                    get().propuestasStore[0].abierto = true;
            break; 
            //default: break;
        } 
        //console.log ('4:::::::::::::::::::::::cambiaPropuestasStore- propuestasStore: ', get().propuestasStore );
      },

  insertbyUserStore:{},

      //*Tarea: InsertbyUser // entra desde PropuestaNueva - botón: Guardar - cuando la propuesta es nueva
      guardaInsertbyUserStore: async (responseAPI:any, bodyAPI:any, pasoProcessxfrequency:any, catO:any, catP:any) => {  
        console.log('1.:::guardaInsertbyUserStore-propuestasStore:', get().propuestasStore);
        //console.log('bodyAPI:', bodyAPI);
        //console.log('pasoProcessxfrequency:', pasoProcessxfrequency);
        //console.log('catO:', catO);
        //console.log('catP:', catP);
        if ( responseAPI.ret==1 ) { //inserto sin error
            set( { insertbyUserStore: responseAPI.rep } );
            //console.log('insertbyUser:', get().insertbyUserStore);
          
            let date = new Date();
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();
            let fecha = '';
            if (month < 10) { fecha= `${year}-0${month}-${day}`}
            else { fecha= `${year}-${month}-${day}`};

            get().propuestaNvaStore= { 
              id: get().insertbyUserStore.id, folio: get().insertbyUserStore.folio, description: bodyAPI.description, createdAt: get().insertbyUserStore.createdat, sentAt: null, sent: false, 
              abierto: true, eliminado: false,  estatusTexto: 'No enviada', fecha:fecha, nombreCorto: '', 
              propuestaDetalles:{ 
                id: get().insertbyUserStore.id, folio: get().insertbyUserStore.folio, description: bodyAPI.description, createdAt: get().insertbyUserStore.createdat, sentAt: null, sent: false, 
                user:{}, origin: bodyAPI.origin, processxfrequency: pasoProcessxfrequency,
                btnGuardar:false, btnEnviar:false,  btnEliminar:false, fecha: fecha, estatusTexto: 'No enviada', 
                miCatOrigenes: catO,
                miCatProcesos: catP
              }
            };
            get().propuestaNvaStore.nombreCorto = (bodyAPI.description.length > 50) ? bodyAPI.description.substring(0,10) + '...' : bodyAPI.description;  
          
            get().propuestasStore.unshift(get().propuestaNvaStore); //agrego la propuesta al arreglo en la primera posición
            //set( { propuestaDetallesStore: get().propuestaNvaStore.propuestaDetalles } ) // asignamos a propuesta detalle
            
            //console.log('2.:::guardaInsertbyUserStore-propuestasStore:', get().propuestasStore);
            //console.log('3.:::guardaInsertbyUserStore-propuestaDetallesStore:', get().propuestaDetallesStore);

            return(get().insertbyUserStore);
        }
        else {
            get().generaObjErrorProposalsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'proposals.store-guardaInsertbyUserStore')
        }
      },

      cambiaPropuestaDetallesStore: ( id:any, detalle:any, dondeViene:any) => { 
        //alert('cambiaPropuestaDetallesStore - id: ' + id +  ' dondeViene: ' + dondeViene)
        //console.log('cambiaPropuestaDetallesStore - id: ', id ,' dondeViene: ', dondeViene,' detalle: ', detalle)
        switch (dondeViene){
            case 'insertbyUserStore': 
                  get().propuestaDetallesStore  = detalle;
            break;
        } 
        //console.log (':::::cambiaPropuestaDetallesStore- propuestaDetallesStore: ', get().propuestaDetallesStore );
      },
    
  updatebyUserStore:{},

      //*Tarea: UpdatebyUser
      //entra desde Propuesta- botón: Guardar - cuando la propuesta es existente
      guardaUpdatebyUserStore: async (responseAPI:any, bodyAPI:any, catO:any, catP:any) => {  
        if ( responseAPI.ret==1 ) { //inserto sin error
            set( { updatebyUserStore: responseAPI } );
            //console.log('updatebyUserStore:', get().updatebyUserStore);
            //actualizar el encabezado y propuestaDetalles de propuestasStore
            get().propuestasStore.map((p:any) => { 
                if (p.id==bodyAPI.id) {
                    p.description = bodyAPI.description;
                    p.propuestaDetalles.description = bodyAPI.description;
                    p.propuestaDetalles.btnGuardar = false;
                    p.propuestaDetalles.miCatOrigenes = catO;
                    p.propuestaDetalles.miCatProcesos = catP;
                }
            }); 
            //console.log(':::guardaUpdatebyUserStore-propuestasStore:', get().propuestasStore);
            return(get().updatebyUserStore);
        }
        else {
          get().generaObjErrorProposalsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'proposals.store-guardaUpdatebyUserStore')
        }
      },
    
  deletebyUserStore:{},

      //*Tarea: DeletebyUser
      //entra desde Propuesta - botón: Eliminar - cuando la propuesta es existente
      guardaDeletebyUserStore: async (responseAPI:any) => {  
        set( { deletebyUserStore: responseAPI } );
        if ( get().deletebyUserStore.ret==1 ) { //inserto sin error
            //console.log(':::deletebyUserStore:', get().deletebyUserStore);
            return(get().deletebyUserStore);
        }
        else {
          get().generaObjErrorProposalsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'proposals.store-guardaDeletebyUserStore')
        }
      },

      //agrega eliminado al registro para que no sea visualizado en el front, la baja real entra cuando se vuelve a cargar el api
      eliminaPropuestasStore: ( id:any ) => { 
        //alert('eliminaPropuestasStore'+id)
        //console.log('::::eliminaPropuestasStore - id: ', id )
        get().propuestasStore.map((p:any) => {
          if (p.id==id)  
              p.eliminado = true;
        }); 
        console.log (':::eliminaPropuestasStore - propuestasStore: ', get().propuestasStore );
      },

  sendbyUserStore:{},

      //*Tarea: SendbyUser //entra desde Propuesta - botón: Enviar - cuando la propuesta es existente
      guardaSendbyUser: async (responseAPI:any) => { 
        console.log('::::::: guardaSendbyUser', responseAPI) 
        set( { sendbyUserStore: responseAPI } );
        if ( get().sendbyUserStore.ret==1 ) { //inserto sin error
            //console.log('sendbyUserStore:', get().sendbyUserStore);
            return(get().sendbyUserStore);
        }
        else {
          get().generaObjErrorProposalsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'proposals.store-guardaSendbyUser')
        }
      },

      //*Cambio estatus "abierto" a false para cerrar la propuesta
      // entra desde Propuestas - paneles de encabezados
      cierraPropuestaStore: async (id:any) => {  
        //console.log (p.id);
        get().propuestasStore.map((p:any) => {
          if (p.id == id)
            p.abierto = false
        });  
        //console.log (':::propuestasStore: **', get().propuestasStore );
      },
 
}));

export default proposalsStore;
